import { contarNoLeidos as apiContarNoLeidos } from 'api/solicitudes/chat'
import { useEffect, useMemo, useState } from 'react'

const keyDe = (codigo, origen) => `${codigo}|${origen}`

const useNoLeidosPorSolicitud = (pares) => {
  const [contadores, setContadores] = useState(new Map())
  const [refrescando, setRefrescando] = useState(false)

  const paresKey = useMemo(
    () => (pares || []).map((p) => keyDe(p.codigo, p.origen)).join(','),
    [pares],
  )

  useEffect(() => {
    if (!pares || pares.length === 0) {
      setContadores(new Map())
      return
    }
    setRefrescando(true)
    apiContarNoLeidos(pares)
      .then((data) => {
        const m = new Map()
        ;(data || []).forEach((row) => {
          m.set(keyDe(row.codigo_solicitud, row.origen_solicitud), row.mensajes_no_leidos || 0)
        })
        setContadores(m)
      })
      .catch(() => setContadores(new Map()))
      .finally(() => setRefrescando(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paresKey])

  return { contadores, refrescando }
}

export default useNoLeidosPorSolicitud
